const loginSelectors = {
  recoverPasswordFormTriggers: '[data-recover-toggle]',
  recoverPasswordForm: '[data-recover-form]',
  loginForm: '[data-login-form]',
  formState: '[data-recover-form-state]',
  resetSuccess: '[data-reset-success]',
};

function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}

function checkUrlHash() {
  const hash = window.location.hash;
  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
  document
    .querySelector(loginSelectors.recoverPasswordForm)
    .classList.toggle('hide');
  document.querySelector(loginSelectors.loginForm).classList.toggle('hide');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
  // check if reset password form was
  // successfully submitted and show success message.
  if (document.querySelector(loginSelectors.formState)) {
    document
      .querySelector(loginSelectors.resetSuccess)
      .classList.remove('hide');
  }
}

/**
 * Initialize login form functionality
 * Called on page load and after InstantClick navigation
 */
function initLoginForm() {
  if (document.querySelector(loginSelectors.recoverPasswordForm)) {
    checkUrlHash();
    resetPasswordSuccess();

    document
      .querySelectorAll(loginSelectors.recoverPasswordFormTriggers)
      .forEach((trigger) => {
        trigger.addEventListener('click', onShowHidePasswordForm);
      });
  }
}

// Initialize on page load
initLoginForm();

// Re-initialize after InstantClick navigation
if (typeof InstantClick !== 'undefined') {
  InstantClick.on('change', function () {
    initLoginForm();
  });
}

const addressSelectors = {
  addressContainer: '[data-address]',
  addressFields: '[data-address-fields]',
  addressToggle: '[data-address-toggle]',
  addressForm: '[data-address-form]',
  addressDeleteForm: '[data-address-delete-form]',
};
const hideClass = 'hide';

function initializeAddressForm(container) {
  const addressFields = container.querySelector(addressSelectors.addressFields);
  const addressForm = container.querySelector(addressSelectors.addressForm);
  const deleteForm = container.querySelector(
    addressSelectors.addressDeleteForm
  );

  container
    .querySelectorAll(addressSelectors.addressToggle)
    .forEach((button) => {
      button.addEventListener('click', () => {
        addressForm.classList.toggle(hideClass);
      });
    });

  window.Shopify.theme.addresses.AddressForm(addressFields, 'en');

  if (deleteForm) {
    deleteForm.addEventListener('submit', (event) => {
      const confirmMessage = deleteForm.getAttribute('data-confirm-message');

      if (
        !window.confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        event.preventDefault();
      }
    });
  }
}

const addressForms = document.querySelectorAll(
  addressSelectors.addressContainer
);

if (addressForms.length) {
  addressForms.forEach((addressContainer) => {
    initializeAddressForm(addressContainer);
  });
}
